import type {
  InterstateOnChangeEvent,
  TextInputEventValue
} from "@dealer-center/core-components";
import { NumericInput } from "@dealer-center/core-components";

import styled from "styled-components";
import type { numberInputs } from "..";
import { configItemContext } from "..";
import { useContext } from "react";
import {
  StyledIconInfoOutline,
  StyledImport,
  StyledImportedText,
  StyledInput,
  StyledInputWrapper
} from "./styles";

interface PagesInventoryConfigUiConfigDispayInputNumericInterface {
  item: numberInputs;
}
// inherit from StyledInput
const StyledNumericInput = styled(NumericInput)<{
  imported: boolean;
  importExists: boolean;
}>`
  ${StyledInput}
`;

export const ConfigNumber = ({
  item
}: PagesInventoryConfigUiConfigDispayInputNumericInterface) => {
  const {
    curentConfig,
    setCurrentConfigValue,
    importedConfig,
    selectedConfig
  } = useContext(configItemContext);

  const currentConfigItem = curentConfig[item.dataIndex] as string;
  const importedConfigItem = importedConfig?.[item.dataIndex] as string;
  const selectedConfigItem = selectedConfig?.[item.dataIndex] as string;
  const isUsingImportedValue =
    currentConfigItem === importedConfigItem &&
    currentConfigItem !== selectedConfigItem;

  const onChange = (e: InterstateOnChangeEvent<TextInputEventValue>) => {
    const rawInput = e.target.value.replace(/,/g, "");
    const value =
      rawInput === "" || isNaN(Number(rawInput)) ? 0 : Number(rawInput);
    setCurrentConfigValue({
      key: item.dataIndex,
      value
    });
  };
  return (
    <StyledInputWrapper>
      <StyledNumericInput
        autoInsertCommas={item.autoInsertCommas}
        disabled={item.disabled || false}
        id={item.dataIndex}
        importExists={importedConfig !== undefined}
        imported={isUsingImportedValue}
        label={item.label}
        name={item.dataIndex}
        value={currentConfigItem}
        onChange={onChange}
      />
      {isUsingImportedValue && (
        <StyledImport>
          <StyledIconInfoOutline title="Using imported value" />
          <StyledImportedText>Using imported value</StyledImportedText>
        </StyledImport>
      )}
    </StyledInputWrapper>
  );
};
